import { Box, Stack, Typography } from "@mui/material";
import PoColumnField from "./PoColumnField";
import { poColors, poFieldControlSx, poFieldLabelSx } from "./poUi";

/**
 * General section: 4 inputs per row (label above control for density / readability).
 */
const PoGeneralHeaderGrid = ({
	columns = [],
	leftColumns = [],
	rightColumns = [],
	footerColumns = [],
	rowColumns = [],
	data,
	setData,
	readOnly = false,
	masterLabels = {},
}) => {
	const gridColumns =
		columns.length > 0
			? columns
			: [...(leftColumns || []), ...(rightColumns || [])].filter(Boolean);

	const renderField = (column, { fullWidth = false } = {}) => {
		const required = !!column?.constraints?.NOTNULL;
		return (
			<Box
				key={column.key}
				sx={{
					minWidth: 0,
					gridColumn: fullWidth ? "1 / -1" : "auto",
				}}>
				<Typography component="label" sx={poFieldLabelSx}>
					{column.name}
					{required ? (
						<Box component="span" sx={{ color: poColors.danger, ml: 0.25 }}>
							*
						</Box>
					) : null}
				</Typography>
				<Box sx={poFieldControlSx}>
					<PoColumnField
						column={column}
						data={data}
						setData={setData}
						readOnly={readOnly || !!column.disabled}
						width="100%"
						dense
						hideLabel
					/>
				</Box>
			</Box>
		);
	};

	return (
		<Stack spacing={1}>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: {
						xs: "1fr",
						sm: "1fr 1fr",
						md: "1fr 1fr 1fr",
						lg: "1fr 1fr 1fr 1fr",
					},
					columnGap: { xs: 1.5, md: 1.75 },
					rowGap: { xs: 1.25, md: 1.35 },
					alignItems: "start",
				}}>
				{gridColumns.map((column) => renderField(column))}
			</Box>
			{rowColumns.length > 0 && (
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
						columnGap: { xs: 1.5, md: 1.75 },
						rowGap: { xs: 1.25, md: 1.35 },
						maxWidth: { sm: "50%" },
						alignItems: "start",
					}}>
					{rowColumns.map((column) => renderField(column))}
				</Box>
			)}
			{footerColumns.length > 0 && (
				<Box
					sx={{
						pt: 0.75,
						mt: 0.15,
						borderTop: `1px solid ${poColors.line}`,
						display: "grid",
						gridTemplateColumns: "1fr",
						rowGap: 1,
					}}>
					{footerColumns.map((column) => renderField(column, { fullWidth: true }))}
				</Box>
			)}
		</Stack>
	);
};

export default PoGeneralHeaderGrid;
